export default class ValidationUtils {
  public static checkStringIsNullOrEmpty(value: string | undefined): boolean {
    return value == null || value === "";
  }
}
